import { TextBody, TextTitle } from '@tkww/orion-web-ds-text';
import React from 'react';
import Styles from './CongratsBooking.scss';
import CheersIllustrationSrc from './cheers-illustration.svg';

export interface CongratsBookingProps {
	vendorName: string;
}

export const CongratsBooking = ({ vendorName }: CongratsBookingProps) => {
	return (
		<div className={Styles.container}>
			<img
				aria-hidden="true"
				className={Styles.illustration}
				src={CheersIllustrationSrc}
				alt=""
			/>
			<TextTitle size="xs" className={Styles.title}>
				Congrats! You booked {vendorName}.
			</TextTitle>
			<TextBody size="md">
				Stay on this page—we’re searching the best vendors for your wedding!
			</TextBody>
		</div>
	);
};
